import config from '../config';

const url = config.backend;

function asyncFetchRatingsRequest(ratings) {
	return {
		type: 'ASYNC_FETCH_RATINGS_REQUEST',
		ratings
	}
}

function asyncFetchRatingsSuccess(data) {
	return {
		type: 'ASYNC_FETCH_RATINGS_SUCCESS',
		data
	}
}

function asyncFetchRatingsError(error) {
	return {
		type: 'ASYNC_FETCH_RATINGS_ERROR',
		error
	}
}


function asyncSubmitVoteRequest() {
	return {
		type: 'ASYNC_SUBMIT_VOTE_REQUEST'
	}
}

function asyncSubmitVoteSuccess(data) {
	return {
		type: 'ASYNC_SUBMIT_VOTE_SUCCESS',
		data
	}
}

function asyncSubmitVoteError(error) {
	return {
		type: 'ASYNC_SUBMIT_VOTE_ERROR',
		error
	}
}

export function setPosition(val) {
	return {
		type:'SET_POSITION_VALUE',
		position: val
	}
}

export function asyncFetchRatings(id, type) {
	return (dispatch) => {
		dispatch(asyncFetchRatingsRequest());

	 	fetch(`${url}/${id}/${type}`)
    .then(response => {
      return response.json();
    })
    .then(data => dispatch(asyncFetchRatingsSuccess(data)))
    .catch(error => dispatch(asyncFetchRatingsError(error)));
	}
}

export function asyncSubmitVote(id, type, val) {
	return (dispatch) => {
		dispatch(asyncSubmitVoteRequest());
 
    fetch(url, {
      method: 'POST',
      body: JSON.stringify({id, type, vote: val}),
      headers: {
        'content-type': 'application/json'
      },
    })
    .then(response => {
      return response.json();
    })
    .then(data => dispatch(asyncSubmitVoteSuccess(data)))
    .catch(error => dispatch(asyncSubmitVoteError(error)));
	}
}


// WEBPACK FOOTER //
// ./src/state/actions.js